import React, { useCallback, useEffect, useState } from 'react';
import { Colors as C } from '../../constants/Colors.js';
import { DCard, BtnGold } from './MarketplaceAtoms.js';
import { logisticsFromRoleData } from '../constants/partnerLogistics.js';
import { updatePartnerRoleLogistics } from '../../lib/listingPartnerLogisticsService.js';

const TOGGLE_ROWS = [
  { key: 'seller_dropoff_physical', label: 'Recibe entrega física del vendedor' },
  { key: 'seller_dropoff_shipment', label: 'Recibe envíos del vendedor' },
  { key: 'buyer_handover_physical', label: 'Entrega física al comprador (recogida)' },
  { key: 'buyer_outbound_shipment', label: 'Realiza envíos al comprador' },
];

export default function SectionPartnerLogistics({ role, roleRow, onError, onSuccess }) {
  const [values, setValues] = useState(() => logisticsFromRoleData(roleRow?.role_data));
  const [saving, setSaving] = useState(false);
  const [savedMsg, setSavedMsg] = useState('');

  useEffect(() => {
    setValues(logisticsFromRoleData(roleRow?.role_data));
  }, [roleRow?.id, roleRow?.role_data]);

  const save = useCallback(async () => {
    onError?.('');
    setSavedMsg('');
    if (!values.seller_dropoff_physical && !values.seller_dropoff_shipment) {
      onError?.('Indica al menos una forma de recibir el disco del vendedor.');
      return;
    }
    if (!values.buyer_handover_physical && !values.buyer_outbound_shipment) {
      onError?.('Indica al menos una forma de entregar al comprador.');
      return;
    }
    setSaving(true);
    const { error } = await updatePartnerRoleLogistics({
      role,
      sellerDropoffPhysical: values.seller_dropoff_physical,
      sellerDropoffShipment: values.seller_dropoff_shipment,
      buyerHandoverPhysical: values.buyer_handover_physical,
      buyerOutboundShipment: values.buyer_outbound_shipment,
    });
    setSaving(false);
    if (error) {
      onError?.(error);
      return;
    }
    const msg = 'Capacidades logísticas guardadas.';
    setSavedMsg(msg);
    onSuccess?.(msg);
  }, [role, values, onError, onSuccess]);

  if (!roleRow || roleRow.role_status !== 'active') return null;

  const title = role === 'store' ? 'Logística de tienda' : 'Logística del punto';

  return (
    <DCard style={{ padding: 14, marginBottom: 14, borderColor: 'rgba(200,168,75,0.2)' }}>
      <div style={{ fontSize: 13, fontWeight: 600, color: C.gold, marginBottom: 6 }}>{title}</div>
      <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.45)', marginBottom: 12, lineHeight: 1.45 }}>
        Define qué operaciones puedes realizar. Los vendedores solo podrán elegirte si encajas con su forma de
        entregar el disco.
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 12 }}>
        {TOGGLE_ROWS.map(r => (
          <label
            key={r.key}
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 10,
              fontSize: 11,
              color: 'rgba(255,255,255,0.75)',
              cursor: saving ? 'default' : 'pointer',
            }}
          >
            <input
              type="checkbox"
              checked={!!values[r.key]}
              disabled={saving}
              onChange={e => setValues(v => ({ ...v, [r.key]: e.target.checked }))}
              style={{ marginTop: 2, accentColor: C.gold }}
            />
            <span>{r.label}</span>
          </label>
        ))}
      </div>
      {savedMsg ? <div style={{ fontSize: 10, color: C.green, marginBottom: 8 }}>{savedMsg}</div> : null}
      <BtnGold type="button" disabled={saving} onClick={save} style={{ fontSize: 11, padding: '8px 14px' }}>
        {saving ? 'Guardando…' : 'Guardar logística'}
      </BtnGold>
    </DCard>
  );
}
